import {CarCondition, CarType, CreditScoreType} from '@shared/interfaces';

export enum ActionTypes {
  CREATE_SHORT_LINK = '[Utility] CreateShortLink',
  GET_INTEREST_RATE = '[Utility] GetInterestRate'
}

export class CreateShortLink {
  static readonly type = ActionTypes.CREATE_SHORT_LINK;

  constructor(public payload: { url: string }) {
  }
}

export class GetInterestRate {
  static readonly type = ActionTypes.GET_INTEREST_RATE;

  constructor(public payload: { state: string; creditType: CreditScoreType; carCondition: CarCondition }) {
  }
}
